module.exports = __webpack_public_path__ + "static/media/vip_room_5.77370ade.png";